// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"1055":"Quiz","1984":"ppvx","2143":"app","4026":"loggedOutHeaderFooter","8350":"setup","8808":"appcenter"}[chunkId] + ".css";
};